import { AbstractHook } from '@hooks/abstraction';
import { CrmLeadListService } from '../services/crm-lead-list.service';
import { LeadResponse } from '../services/responses/lead.response';

export class CrmLeadListHook extends AbstractHook<LeadResponse, CrmLeadListService> {}
